export const RESET_ALERTS = 'RESET_ALERTS';
export const CHANGE_HEADER_CONTENT = 'CHANGE_HEADER_CONTENT';
export const RESET_PAGE = 'RESET_PAGE';
export const RESET_ENTITY = 'RESET_ENTITY';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';

// Resets the currently visible error message.
export const resetAlerts = () => ({
	type: RESET_ALERTS
});

export const changeHeaderContent = (content) => ({
	type: CHANGE_HEADER_CONTENT,
	content: content
});

export const resetPage = (name) => ({
	type: RESET_PAGE,
	name
});

export const resetEntity = (name) => ({
	type: RESET_ENTITY,
	name
});

export const showMessage = (message, type = 'success') => {
	if (type === 'success') {
		return {
			type: SHOW_MESSAGE,
			success: message
		}
	} else {
		return {
			type: SHOW_MESSAGE,
			error: message
		}
	}
};


// WEBPACK FOOTER //
// ./src/actions/index.js